import React from 'react';
import { string } from 'prop-types';
import { ProductShippingCost } from './product-shipping.styles';
import { MINIATURE } from '../../constants';

const FreeShipping = () => /*#__PURE__*/React.createElement("span", null, "Frete gr\xE1tis");

function ProductShipping({
  cost,
  displayMode,
  costDescription
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, !cost ? null : /*#__PURE__*/React.createElement(ProductShippingCost, {
    "data-testid": "shipping-cost",
    textAlign: displayMode === MINIATURE ? 'center' : null
  }, Number(cost) === 0 ? /*#__PURE__*/React.createElement(FreeShipping, null) : costDescription));
}

process.env.NODE_ENV !== "production" ? ProductShipping.propTypes = {
  cost: string,
  displayMode: string,
  costDescription: string
} : void 0;
export default ProductShipping;